<template>
  <section-meta
    label="Files"
    intro="Add any kind of attachment that might be helpful"
  >
    <item-file class="ps-mt-6" />
    <item-file class="ps-mt-6" />
    <item-file class="ps-mt-6" />
    <item-file class="ps-mt-6" />
    <item-file class="ps-mt-6" />
    <item-file class="ps-mt-6" />
  </section-meta>
</template>

<script>
import ItemFile from '@/components/items/ItemFile'
import SectionMeta from '@/components/SectionMeta'

export default {
  name: 'CardSectionFiles',
  props: {
    msg: String
  },
  components: {
    ItemFile,
    SectionMeta
  }
}
</script>
